import "./StatusStyle.scss";
import { IJSLComponent, IJSLVNode } from "jsl-render";
import { NivEventEntry } from "../../ajax/types/NivEventEntry";
import { StatusEntryComponent } from "./StatusEntryComponent";

export class StatusHistoryComponent implements IJSLComponent {

    // public showAnimation: boolean;

    public constructor(private entries: NivEventEntry[]) { }

    public render(): IJSLVNode {
        return (
            <div class="status-info">
                {this.entries.map((item, idx) => new StatusEntryComponent(item, idx))}
            </div>);
    }
}
